import { styled } from "../../../../../../styles";

export const TableContainer = styled("div", {
  width: "1000px",
  height: "550px",

  display: "flex",
  alignItems: "center",
  marginLeft: "-24px",

  fontSize: "14px",

  th: {
    zIndex: 1,
  },

  variants: {
    isPinnedGraph: {
      true: {
        width: "104.4%",
        height: "500px",
        marginLeft: "-32px",
      },
    },
  },
});

export const ImageContainer = styled("div", {
  overflowY: "overlay",
  maxHeight: "100%",

  zIndex: 1000,

  borderRadius: "8px",

  width: "100%",
  minHeight: "426px",

  backgroundColor: "$white",
  color: "$black",

  boxSizing: "border-box",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "10px",

  p: {
    width: "418px",
    marginTop: "30px",
    textAlign: "center",

    button: {
      background: "none",
      color: "#7562A8",
      border: "none",
      padding: 0,
      font: "inherit",
      cursor: "pointer",
      outline: "inherit",
      fontWeight: "600",
    },
  },
});

export const NoContentMessage = styled("p", {
  marginTop: "10px !important",

  fontFamily: "$openSans",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "21px",
});
